import * as yup from "yup";

export const SchemaSimulator = yup.object().shape({
  amount: yup.string().required("Informe um valor válido."),
});
